import { call, put } from 'redux-saga/effects';

import { deleteSavedFilingPeriodFileFailure } from '@actions/savedFilingPeriod';
import { deleteFileSaga } from '@sagas/savedFilingPeriod/deleteFileSaga';
import { toastError } from '@store/notifications';

export const deleteSavedFilingPeriodFileSaga = function* ({ payload }) {
  try {
    yield call(deleteFileSaga, { payload });
  } catch (error) {
    const { nonFieldErrors } = error.data || {};

    yield put([
      toastError({
        message: nonFieldErrors || {
          defaultMessage: 'An unexpected error occurred, please try again.',
          id: 'global.notification.api-error-default',
        },
      }),
      deleteSavedFilingPeriodFileFailure(payload),
    ]);
  }
};
